import { ThemeUIStyleObject } from "theme-ui";

export const linkCTAStyle: ThemeUIStyleObject = {
  position: "absolute",
  left: "0",
  top: "0",
  width: "100%",
  height: "100%",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
};

export const headingStylesGreen: ThemeUIStyleObject = {
  fontSize: ["h2", "h2", "h1"],
  mb: 0,
  color: "darkGreen",
  textAlign: "center",
  marginBottom: 9,
};

export const headingStylesCollection: ThemeUIStyleObject = {
  fontSize: ["h2", "h2", "h1"],
  mb: 0,
  color: "darkGreen",
  textAlign: "center",
  marginBottom: 15,
};

export const headingStylesRed: ThemeUIStyleObject = {
  fontSize: ["h2", "h2", "h1"],
  mb: 0,
  color: "darkRed",
  textAlign: "center",
};

export const headingStylesRedLeft: ThemeUIStyleObject = {
  fontSize: ["h2", "h2", "h1"],
  mb: 0,
  color: "darkRed",
  textAlign: "left",
  marginBottom: 9,
};

export const mainContainerStyles: ThemeUIStyleObject = {
  position: "relative",
  zIndex: 1,
  bg: "white",
  px: [3, 6],
  pt: [3, 6],
  pb: [3, 6],
};

export const InputStyles: ThemeUIStyleObject = {
  fontFamily: "NyCarlsbergDisplay-Regular",
  color: "darkGreen",
  position: "relative",
  overflow: "hidden",
  display: "inline-flex",
  paddingRight: "6",
  paddingLeft: "11",
  py: "4",
  mr: 1,
  letterSpacing: "wide",
  textAlign: "left",
  borderWidth: "4",
  borderStyle: "solid",
  borderColor: "darkGreen",
  borderRadius: "default",
  maxWidth: "100%",
  "&::placeholder": {
    fontFamily: "NyCarlsbergDisplay-Regular",
    fontSize: "smText",
    textTransform: "uppercase",
  },
  "&:focus": {
    outline: "none",
    boxShadow: "none",
  },
};
